import { useQuery } from '@tanstack/react-query'
import { fetchFunctionalChecklist } from "../services/functional_checklist";

export const useFunctionalChecklistByOrg = (pageNumber = 1, pageSize = 10) => {
    return useQuery({
        queryKey:['functionalChecklistByOrg', pageNumber, pageSize],
        queryFn: () => fetchFunctionalChecklist(pageNumber, pageSize)
    })
}
